import { useContext } from 'react';

import type { TruncationMode } from '@dynatrace/strato-components/typography';

import { CategoricalBarChartTruncationModeContext } from '../contexts/CategoricalBarChartTruncationMode.context.js';

export const useTruncationMode = (): TruncationMode =>
  useContext(CategoricalBarChartTruncationModeContext);
